module.exports = __webpack_public_path__ + "static/media/gitlab.994b56df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/gitlab.png
// module id = 103
// module chunks = 0